import { createSelector } from '@reduxjs/toolkit';
import { State } from '../../../store/state';

export const errorCodeSelector = (state: State) => state.master.errorCode;
export const categorySelector = (state: State) => state.master.category;
export const typeSelector = (state: State) => state.master.type;
export const productAttributeSelector = (state: State) => state.master.productAttribute;
export const formatSelector = (state: State) => state.master.format;
export const genreSelector = (state: State) => state.master.genre;
export const priceRangeSelector = (state: State) => state.master.priceRange;

const productTypesIdsSelector = (state: State) => state.master.productTypes.ids;
const productTypesEntitiesSelector = (state: State) =>
  state.master.productTypes.entities;
export const productTypesSelector = createSelector(
  [productTypesIdsSelector, productTypesEntitiesSelector],
  (ids, entities) => ids.map((id) => entities[id])
);

const productUsagesIdsSelector = (state: State) => state.master.productUsages.ids;
const productUsagesEntitiesSelector = (state: State) =>
  state.master.productUsages.entities;
export const productUsagesSelector = createSelector(
  [productUsagesIdsSelector, productUsagesEntitiesSelector],
  (ids, entities) => ids.map((id) => entities[id])
);

const productPackagingsIdsSelector = (state: State) => state.master.productPackagings.ids;
const productPackagingsEntitiesSelector = (state: State) =>
  state.master.productPackagings.entities;
export const productPackagingsSelector = createSelector(
  [productPackagingsIdsSelector, productPackagingsEntitiesSelector],
  (ids, entities) => ids.map((id) => entities[id])
);

const productFuntionalitiesIdsSelector = (state: State) => state.master.productFuntionalities.ids;
const productFuntionalitiesEntitiesSelector = (state: State) =>
  state.master.productFuntionalities.entities;
export const productFuntionalitiesSelector = createSelector(
  [productFuntionalitiesIdsSelector, productFuntionalitiesEntitiesSelector],
  (ids, entities) => ids.map((id) => entities[id])
);

const productAestheticsIdsSelector = (state: State) => state.master.productAesthetics.ids;
const productAestheticsEntitiesSelector = (state: State) =>
  state.master.productAesthetics.entities;
export const productAestheticsSelector = createSelector(
  [productAestheticsIdsSelector, productAestheticsEntitiesSelector],
  (ids, entities) => ids.map((id) => entities[id])
);

const productCompletenessesIdsSelector = (state: State) => state.master.productCompletenesses.ids;
const productCompletenessesEntitiesSelector = (state: State) =>
  state.master.productCompletenesses.entities;
export const productCompletenessesSelector = createSelector(
  [productCompletenessesIdsSelector, productCompletenessesEntitiesSelector],
  (ids, entities) => ids.map((id) => entities[id])
);

const productStatesIdsSelector = (state: State) => state.master.productStates.ids;
const productStatesEntitiesSelector = (state: State) =>
  state.master.productStates.entities;
export const productStatesSelector = createSelector(
  [productStatesIdsSelector, productStatesEntitiesSelector],
  (ids, entities) => ids.map((id) => entities[id])
);

const warehouseTypesIdsSelector = (state: State) => state.master.warehouseTypes.ids;
const warehouseTypesEntitiesSelector = (state: State) =>
  state.master.warehouseTypes.entities;
export const warehouseTypesSelector = createSelector(
  [warehouseTypesIdsSelector, warehouseTypesEntitiesSelector],
  (ids, entities) => ids.map((id) => entities[id])
);

const locationTypesIdsSelector = (state: State) => state.master.locationTypes.ids;
const locationTypesEntitiesSelector = (state: State) =>
  state.master.locationTypes.entities;
export const locationTypesSelector = createSelector(
  [locationTypesIdsSelector, locationTypesEntitiesSelector],
  (ids, entities) => ids.map((id) => entities[id])
);

const containerTypesIdsSelector = (state: State) => state.master.containerTypes.ids;
const containerTypesEntitiesSelector = (state: State) =>
  state.master.containerTypes.entities;
export const containerTypesSelector = createSelector(
  [containerTypesIdsSelector, containerTypesEntitiesSelector],
  (ids, entities) => ids.map((id) => entities[id])
);

const channelTypesIdsSelector = (state: State) => state.master.channelTypes.ids;
const channelTypesEntitiesSelector = (state: State) =>
  state.master.channelTypes.entities;
export const channelTypesSelector = createSelector(
  [channelTypesIdsSelector, channelTypesEntitiesSelector],
  (ids, entities) => ids.map((id) => entities[id])
);

const acquisitionTypesIdsSelector = (state: State) => state.master.acquisitionTypes.ids;
const acquisitionTypesEntitiesSelector = (state: State) =>
  state.master.acquisitionTypes.entities;
export const acquisitionTypesSelector = createSelector(
  [acquisitionTypesIdsSelector, acquisitionTypesEntitiesSelector],
  (ids, entities) => ids.map((id) => entities[id])
);

const receptionTypesIdsSelector = (state: State) => state.master.receptionTypes.ids;
const receptionTypesEntitiesSelector = (state: State) =>
  state.master.receptionTypes.entities;
export const receptionTypesSelector = createSelector(
  [receptionTypesIdsSelector, receptionTypesEntitiesSelector],
  (ids, entities) => ids.map((id) => entities[id])
);

const productCategoriesIdsSelector = (state: State) => state.master.productCategories.ids;
const productCategoriesEntitiesSelector = (state: State) =>
  state.master.productCategories.entities;
export const productCategoriesSelector = createSelector(
  [productCategoriesIdsSelector, productCategoriesEntitiesSelector],
  (ids, entities) => ids.map((id) => entities[id])
);

const containerCategoriesIdsSelector = (state: State) => state.master.containerCategories.ids;
const containerCategoriesEntitiesSelector = (state: State) =>
  state.master.containerCategories.entities;
export const containerCategoriesSelector = createSelector(
  [containerCategoriesIdsSelector, containerCategoriesEntitiesSelector],
  (ids, entities) => ids.map((id) => entities[id])
);

const formatsIdsSelector = (state: State) => state.master.formats.ids;
const formatsEntitiesSelector = (state: State) =>
  state.master.formats.entities;
export const formatsSelector = createSelector(
  [formatsIdsSelector, formatsEntitiesSelector],
  (ids, entities) => ids.map((id) => entities[id])
);

const genresIdsSelector = (state: State) => state.master.genres.ids;
const genresEntitiesSelector = (state: State) =>
  state.master.genres.entities;
export const genresSelector = createSelector(
  [genresIdsSelector, genresEntitiesSelector],
  (ids, entities) => ids.map((id) => entities[id])
);

const priceRangesIdsSelector = (state: State) => state.master.priceRanges.ids;
const priceRangesEntitiesSelector = (state: State) =>
  state.master.priceRanges.entities;
export const priceRangesSelector = createSelector(
  [priceRangesIdsSelector, priceRangesEntitiesSelector],
  (ids, entities) => ids.map((id) => entities[id])
);

const containerRecipientTypesIdsSelector = (state: State) => state.master.containerRecipientTypes?.ids || [];
const containerRecipientTypesEntitiesSelector = (state: State) =>
  state.master.containerRecipientTypes?.entities || {};

export const containerRecipientTypesSelector = createSelector(
  [containerRecipientTypesIdsSelector, containerRecipientTypesEntitiesSelector],
  (ids, entities) => ids.map((id) => entities[id])
);
